export default class FlashTimer {
  constructor ({
    duration,
    onProgress,
    onComplete,
    now = () => performance.now(),
    requestFrame = (callback) => requestAnimationFrame(callback),
    cancelFrame = (id) => cancelAnimationFrame(id)
  }) {
    this.duration = duration
    this.onProgress = onProgress
    this.onComplete = onComplete
    this.now = now
    this.requestFrame = requestFrame
    this.cancelFrame = cancelFrame
    this.onFrame = this.onFrame.bind(this)
    this.remaining = duration
    this.running = false
    this.completed = false
  }

  start () {
    this.stop()
    this.remaining = this.duration
    this.completed = false
    this.onProgress(1)
    this.resume()
  }

  pause () {
    if (!this.running) return

    this.updateRemaining()
    this.running = false
    this.cancelFrame(this.frameId)
  }

  resume () {
    if (this.running || this.completed || this.remaining <= 0) return

    this.startedAt = this.now()
    this.running = true
    this.frameId = this.requestFrame(this.onFrame)
  }

  stop () {
    if (this.frameId) this.cancelFrame(this.frameId)

    this.running = false
    this.frameId = null
  }

  onFrame () {
    this.updateRemaining()

    if (this.remaining <= 0) {
      this.running = false
      this.completed = true
      this.onComplete()
      return
    }

    this.frameId = this.requestFrame(this.onFrame)
  }

  updateRemaining () {
    const elapsed = this.now() - this.startedAt

    this.remaining = Math.max(0, this.remaining - elapsed)
    this.startedAt = this.now()
    this.onProgress(this.remaining / this.duration)
  }
}
